import { SelectUI } from "../constant/select-ui.constant";

export class UIValidator {
  public static isValidSelectOption(option: string): boolean {
    return option !== SelectUI.DEFAULT_IDX ? true : false;
  }

  public static isNumberEvent(charCode: number): boolean {
    const isGreaterThan = charCode > 31 ? true : false;
    const isBetweenNumbers = charCode < 48 || charCode > 57 ? true : false;
    const isDifferentFrom = charCode !== 46 ? true : false;

    if (isGreaterThan && isBetweenNumbers && isDifferentFrom) {
      return false;
    } else {
      return true;
    }
  }

  public static isEmptyString(value: string): boolean {
    return value === "" ? true : false;
  }

  public static isEmptyArray(array: any[]): boolean {
    return array.length === 0 ? true : false;
  }

  public static isNull(value: any): boolean {
    return value === null ? true : false;
  }

  public static isNotNull(value: any): boolean {
    return value === null ? false : true;
  }
}
